import React from 'react'
import { Box, Button } from '@mui/material'

interface Props {
  onBack: () => void
  onNext: () => void
  isFirstStep?: boolean
  isLastStep?: boolean
  nextLabel?: React.ReactNode
  submitDisabled?: boolean
  onSubmit?: () => void
}

const StepNavigation: React.FC<Props> = ({
  onBack,
  onNext,
  isFirstStep,
  isLastStep,
  nextLabel,
  submitDisabled,
  onSubmit,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
      <Button variant="outlined" onClick={onBack} disabled={isFirstStep}>
        Back
      </Button>
      {isLastStep ? (
        <Button
          variant="contained"
          color="secondary"
          onClick={onSubmit || onNext}
          disabled={submitDisabled}
        >
          {nextLabel || 'Create Campaign'}
        </Button>
      ) : (
        <Button variant="contained" color="secondary" onClick={onNext}>
          {nextLabel || 'Next'}
        </Button>
      )}
    </Box>
  )
}

export default StepNavigation
